const data = (state) => {
  if (state.coaches == null) {
    return null;
  }

  return state.coaches.filter((item) =>
    state.coachSelected.includes(item.id.toString())
  );
};

export default data;
